import React from "react";
import {observer} from "mobx-react";
import {MiniSafezoneBox} from "./boxes/mini-safezone.box";
import {OrbitComponent} from "../../base-components/orbit-component/orbit-component";
import {SAFEZONE_CONTAINERS_ID, OPEN_SAFEZONE_SOURCE_VALUES, CLOSE_SAFEZONE_SOURCE_VALUES} from "../../../services/safezone/safezone.service.interface";
import {AreaType} from "@sparkware/uc-sdk-core";
import {CHANNEL_ELEMENTS, CHANNEL_SOURCE} from "../../../../common/const/casinofied-analytics-consts";
import {ICasinofiedApplication} from "../../../services/casinofied/app-launcher/apps/casinofied-application.interface";

@observer
export class MiniSafezoneComponent extends OrbitComponent {
  private iApplication: ICasinofiedApplication | null = null;
  private appLoadingInProgress = false;
  private cancelLoadingApp = false;
  private businessCorrelationID: string;
  private closeSafezoneReason: CLOSE_SAFEZONE_SOURCE_VALUES;

  componentDidMount() {
    super.componentDidMount();
    this.businessCorrelationID = this.services.tools.getGuid();
    if (this.services.safezone.isEnabled && this.services.userMenu.isOpen) {
      this.loadControlCenterMini();
    }
  }

  componentDidUpdate() {
    if (this.services.safezone.isEnabled) {
      if (!this.services.userMenu.isOpen) {
        // so, the userMenu has closed. good. If we have an app, dispose of it
        if (this.iApplication) {
          this.disposeApplication();
        } else if (this.appLoadingInProgress) {
        // but what if the user closed the menu before the app finished loading?
          this.cancelLoadingApp = true;
        }
      }
      if (!this.iApplication && this.services.userMenu.isOpen) {
        this.loadControlCenterMini();
      }
    }
  }

  componentWillUnmount() {
    this.disposeApplication();
  }

  loadControlCenterMini() {
    this.closeSafezoneReason = CLOSE_SAFEZONE_SOURCE_VALUES.CLIENT;
    this.appLoadingInProgress = true;
    this.services.appLauncher.openControlCenterMini({
      businessCorrelationID: this.businessCorrelationID,
      channel: {
        area: AreaType.UserArea,
        element: CHANNEL_ELEMENTS.safezoneHeaderButton,
        source: CHANNEL_SOURCE.casinoClient
      },
      appSpecificParameters: {
        source: OPEN_SAFEZONE_SOURCE_VALUES.USER_AREA
      }
    }).then((app) => {
      this.iApplication = app;
      this.appLoadingInProgress = false;
      if (this.cancelLoadingApp) {
        this.cancelLoadingApp = false;
        this.disposeApplication();
      }
    }).finally(() => {
      this.appLoadingInProgress = false;
      this.cancelLoadingApp = false;
    });
  }
  disposeApplication() {
    if (this.iApplication) {
      this.iApplication.close({
        channel: {
          area: AreaType.UserArea,
          source: CHANNEL_SOURCE.casinoClient
        },
        reason: this.closeSafezoneReason
      });
      this.iApplication = null;
    }
  }

  safezoneBoxClickHandler = () => {
    this.closeSafezoneReason = CLOSE_SAFEZONE_SOURCE_VALUES.MINI_SZ;
  }

  render() {
    if (!this.services.safezone.isEnabled || this.services.safezone.hasError) {
      return null;
    }
    /* Normally why do I care if userMenu.isOpen ? After all, this component is rendered inside the userMenu and will be visible only if isOpen.
    Yes, BUT control center want's to be "closed" and "opened" with every close/open of the userMenu. So I add a class depending on
    this.services.userMenu.isOpen to trigger a componentDidMount and the magic will happen there */
    return (
      <MiniSafezoneBox
          id={SAFEZONE_CONTAINERS_ID.MINI_SAFEZONE_CONTAINER_ID}
          className={"cy-mini-safezone " + (this.services.userMenu.isOpen ? "cy-mini-safezone-open" : "cy-mini-safezone-closed")}
          onClick={this.safezoneBoxClickHandler}
      />
    );
  }
}
